module.exports = __webpack_public_path__ + "static/media/linkedin-jobs.20499e14.svg";